


import React from "react";

import ReactDOM from "react-dom/client";
import App from "./App";
import { msalConfig } from "./authConfig";
import "./globals.css";
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  PublicClientApplication,
} from "@azure/msal-browser";

import 'ag-grid-enterprise';

import {  LicenseManager } from 'ag-grid-enterprise';
// import { ModuleRegistry } from 'ag-grid-community';

// ModuleRegistry.registerModules([AllEnterpriseModule]);

const licenseKey = process.env.REACT_APP_AG_GRID_LICENSE_KEY;

if(licenseKey){
  LicenseManager.setLicenseKey(licenseKey)
}else{
  console.warn("License key not found for AG GRID")
}

export const msalInstance = new PublicClientApplication(msalConfig);

const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
